import { useState } from "react";
import { createContext } from "react";
import { useDispatch } from "react-redux";

import {
  setLoadingFalseAction,
  setLoadingTrueAction,
} from "../../../redux/actions/loadingActions/loadingActions";
import {
  deliverySuccessMessage,
  modalErrorMessage,
  toastErrorMessage,
} from "../../../utils/toastMessage/toastMessage";
import {
  checkHealthSnappTripAdminService,
  getUserSnappTripAdminService,
  loginSnappTripAdminService,
} from "../../../services/adminServices";

export const snappTripAdminContext = createContext({
  info: {},
  setInfo: () => {},
  handleLogin: () => {},
  handleGetUser: () => {},
  handleCheckHealth: () => {},
});

const SnappTripAdminContext = ({ children }) => {
  const dispatch = useDispatch();

  const [info, setInfo] = useState({});

  // Login
  const handleLogin = async () => {
    try {
      dispatch(setLoadingTrueAction());
      const { status, data } = await loginSnappTripAdminService();
      if (status === 200) {
        setInfo(data.result);
      }
    } catch ({ response }) {
      if (response) {
        if (response.status) {
          toastErrorMessage(response.data.resultMessage);
        }
      }
    } finally {
      dispatch(setLoadingFalseAction());
    }
  };

  // Get User
  const handleGetUser = async () => {
    try {
      dispatch(setLoadingTrueAction());
      const { status, data } = await getUserSnappTripAdminService();
      if (status === 200) {
        setInfo(data.result);
      }
    } catch ({ response }) {
      if (response) {
        if (response.status) {
          toastErrorMessage(response.data.resultMessage);
        }
      }
    } finally {
      dispatch(setLoadingFalseAction());
    }
  };

  // Check Health
  const handleCheckHealth = async () => {
    try {
      dispatch(setLoadingTrueAction());
      const { status, data } = await checkHealthSnappTripAdminService();
      if (status === 200) {
        if (data.result?.status === "ok")
          deliverySuccessMessage(
            "اتصال با اسنپ تریپ بر قرار است",
            null,
            "3000"
          );
        else
          modalErrorMessage(
            "اتصال با اسنپ تریپ با مشکل مواجه شده است",
            null,
            "3000"
          );
      }
    } catch ({ response }) {
      if (response) {
        if (response.status) {
          toastErrorMessage(response.data.resultMessage);
        }
      }
    } finally {
      dispatch(setLoadingFalseAction());
    }
  };

  return (
    <snappTripAdminContext.Provider
      value={{ info, setInfo, handleLogin, handleGetUser, handleCheckHealth }}
    >
      {children}
    </snappTripAdminContext.Provider>
  );
};

export default SnappTripAdminContext;
